var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-btn',{staticClass:"ml-5",attrs:{"color":"primary"},on:{"click":_vm.fixImportGridFields}},[_vm._v(" Fix ImportGridFields ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }